//css-------------------
import '../../css/home/tab_layout_cn.scss';
import { createApp } from 'vue/dist/vue.esm-browser.prod.js';
import { data } from './_data_cn.js';

const app = createApp({
    data() {
        return {
            tab_index: 0,
            type_index: 0,
            tab_row: data,
            type_row: [],
            item_row: [],
        }
    },
    watch: {
        tab_index: function() {
            this.type_handler();
            this.item_handler();
        },
        type_index: function() {
            this.item_handler();
        },
    },
    mounted() {
        this.type_handler();
        this.item_handler();
    },
    methods: {
        type_handler() {
            this.type_index = 0;
            this.type_row = [];
            this.type_row = this.tab_row[this.tab_index].data;
        },
        item_handler() {
            this.item_row = [];
            if (this.tab_row[this.tab_index].type_row_show) {
                if (this.type_row[this.type_index].plural) {
                    this.item_row = this.type_row[this.type_index].data;
                } else {
                    this.item_row[0] = this.type_row[this.type_index];
                }
            } else {
                this.item_row = this.type_row;
            }
        },
    },
}).mount('#app');